(function () {
    'use strict';
    //Service to check if booking information has deep link information showing it in a modal
    angular
        .module('ib-checkin-services-module')
        .factory('CheckForDeepLink', CheckForDeepLink);

    CheckForDeepLink.$inject = ['CheckinRouterConstants', '$q', '$uibModal'];
    function CheckForDeepLink (CheckinRouterConstants, $q, $uibModal) {
        const service = {
            checkDeepLink: checkDeepLink
        };

        return service;

        ////////////////
        function checkDeepLink (deepLinkData) {
            const defered = $q.defer();
            let modalInstance;

            if (deepLinkData?.externalCompany && deepLinkData?.externalMobileUrl && deepLinkData?.externalUrl && deepLinkData?.message) {
                modalInstance = $uibModal.open({
                    //   animation: $scope.animationsEnabled,
                    controller: 'IbcoseModalDeepController',
                    controllerAs: 'modalCtrl',
                    templateUrl: CheckinRouterConstants.templatesRoute + 'ibcose.modal-mensaje-deep.html',
                    size: 'md',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        object: function () {
                            return deepLinkData;
                        }
                    }
                });
                modalInstance.result.then(() => {
                    defered.resolve();
                }, () => {
                    defered.resolve();
                });
            } else {
                defered.resolve();
            }

            return defered.promise;
        }
    }
})();